// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueResource from 'vue-resource'
import VueLazyload from 'vue-lazyload'  //引入这个懒加载插件
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import $ from 'jquery'
Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(VueLazyload)
Vue.use(VueViewer)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// if (process.env.NODE_ENV === 'production') {
//     axios.defaults.baseURL = "http://db.xxl-wind.com:8001";
// } else {
//     //axios.defaults.baseURL = "http://localhost:8001";
//     axios.defaults.baseURL = "http://db.xxl-wind.com:8001";
//
//
//     // axios.defaults.baseURL = "http://localhost:9090/api/v1";
// }


// WEBPACK FOOTER //
// ./src/main.js